import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';


const RefundPage = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Refund and Cancellation Policy</h1>
                                </div>
                            </div>
                        </div>
                </section>
                <section className="refund_section section_space pt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                
                                <p><strong>Effective Date:</strong> 1 June 2025</p>

  <p>At <strong>Ease My Hotel</strong>, we strive to provide the highest level of service and satisfaction to our customers. This Refund and Cancellation Policy outlines the terms under which you may cancel your subscription and request a refund.</p>

  <h2>1. Cancellation Policy</h2>
  <ul>
    <li>You may cancel your subscription to <strong>Ease My Hotel</strong> at any time by contacting our support team at <a href="mailto:support@easemyhotel.com">support@easemyhotel.com</a>.</li>
    <li>Upon cancellation, your account will remain active until the end of your current billing cycle. No further charges will be applied after that point.</li>
    <li>Cancellation requests must be made at least <strong>7 business days</strong> before the next billing cycle to avoid being charged for the upcoming period.</li>
  </ul>

  <h2>2. Refund Policy</h2>
  <p>We offer a <strong>14-day refund window</strong> from the date of initial subscription <strong>only in select cases</strong>, which are determined at the sole discretion of Ease My Hotel.</p>

  <p>Refunds are considered under the following conditions:</p>
  <ul>
    <li>The software is not functioning as described and our support team is unable to resolve the issue within a reasonable timeframe.</li>
    <li>The client has not used the software or accessed key features after purchase.</li>
  </ul>

  <p><strong>No refunds</strong> will be issued:</p>
  <ul>
    <li>After the 14-day window has passed.</li>
    <li>For subscription renewals.</li>
    <li>For cancellation requests made after the service has been used extensively.</li>
  </ul>

  <div class="note">
    <strong>Note:</strong> Approval of refund requests is solely at the discretion of the Ease My Hotel support and billing team.
  </div>

  <h2>3. Refund Process</h2>
  <p>If your refund request is approved:</p>
  <ul>
    <li>The amount will be refunded to the original method of payment within <strong>7–10 business days</strong>.</li>
    <li>You will receive an email confirmation once the refund has been processed.</li>
  </ul>

  <h2>4. Modifications to This Policy</h2>
  <p>Ease My Hotel reserves the right to update or modify this Refund and Cancellation Policy at any time. Changes will be posted on this page and will take effect immediately.</p>

  <div class="contact">
    <h2>Contact Us</h2>
    <p>If you have any questions or concerns about this policy, feel free to reach out:</p>
    <p>
      <strong>Ease My Hotel</strong><br />
      📧 Email: <a href="mailto:support@easemyhotel.com">support@easemyhotel.com</a><br />
      📞 Phone: +91-8299406767<br />
      🏢 Address: 117/Q/457/10A, Indrapuri, Sharda Nagar, Kanpur, Uttar Pradesh – 208025, India
    </p>



                            </div>
                             </div>
                        </div>
                    </div>
                </section>
               
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default RefundPage;